(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  function aciumMarkTitleOverflow() {
    document.querySelectorAll(
      '.resource-list product-card [ref="productTitleLink"], .product-grid product-card [ref="productTitleLink"]'
    ).forEach(function (link) {
      var text = link.querySelector('p, h1, h2, h3');
      if (!text) return;
      var overflows = text.scrollWidth > text.offsetWidth + 1;
      if (overflows) {
        text.style.setProperty('--acium-scroll-px', '-' + (text.scrollWidth - text.offsetWidth) + 'px');
        link.classList.add('acium-title-overflows');
      } else {
        text.style.removeProperty('--acium-scroll-px');
        link.classList.remove('acium-title-overflows');
      }
    });
  }

  if (document.readyState !== 'loading') {
    aciumMarkTitleOverflow();
  } else {
    document.addEventListener('DOMContentLoaded', aciumMarkTitleOverflow);
  }
  window.addEventListener('resize', aciumMarkTitleOverflow);
})();
  } catch(e) { console.error(e); }
})();

})();
